<section class="store-locator" appReveal>
  <div class="store-locator__wrapper">
    <div class="store-locator__card">

      <!-- SIDEBAR -->
      <aside class="store-locator__sidebar">

        <div class="store-locator__filters">
          <!-- Search input -->
          <label class="store-locator__search">
            <svg class="store-locator__search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
              <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
            </svg>
            <input
              type="text"
              class="store-locator__search-input"
              i18n-placeholder="@@storeLocator.search.placeholder"
              placeholder="輸入地區或地址搜尋分店..."
              i18n-aria-label="@@storeLocator.search.aria"
              aria-label="搜尋分店"
              [(ngModel)]="query">
          </label>

          <!-- Region chips -->
          <div class="store-locator__chips" role="group" i18n-aria-label="@@storeLocator.regionGroup.aria" aria-label="地區篩選">
            <button
              *ngFor="let chip of regionChips"
              type="button"
              class="store-locator__chip"
              [class.store-locator__chip--active]="activeRegion === chip.value"
              [attr.aria-pressed]="activeRegion === chip.value"
              (click)="selectRegion(chip.value)">
              {{ chip.labelZh }} {{ chip.labelEn }}
            </button>
          </div>

          <!-- Count + sort label (decorative) -->
          <div class="store-locator__meta">
            <p class="store-locator__count" i18n="@@storeLocator.count">共 {{ filteredStores.length }} 間分店</p>
            <span class="store-locator__sort">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
                <path d="M3 6h18M7 12h10M10 18h4"/>
              </svg>
              <ng-container i18n="@@storeLocator.sort">排序: 最近</ng-container>
            </span>
          </div>
        </div>

        <!-- Scrollable store list -->
        <ul class="store-locator__list">
          <li *ngFor="let store of filteredStores; trackBy: trackById">
            <button
              type="button"
              class="store-locator__item"
              [class.store-locator__item--active]="store.id === activeStoreId"
              [attr.aria-current]="store.id === activeStoreId ? 'true' : null"
              (click)="selectStore(store.id)">
              <p class="store-locator__item-title">
                {{ storeName(store) }}
                <span class="store-locator__item-en" *ngIf="storeSubName(store)">{{ storeSubName(store) }}</span>
              </p>
              <p class="store-locator__item-address">
                {{ storeAddress(store) }}<br *ngIf="storeSubAddress(store)">
                {{ storeSubAddress(store) }}
              </p>
              <div class="store-locator__item-meta">
                <span class="store-locator__item-meta-row">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">
                    <circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>
                  </svg>
                  {{ store.hours }}
                </span>
                <span class="store-locator__item-meta-row">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                  {{ store.phone }}
                </span>
              </div>
            </button>
          </li>

          <li *ngIf="filteredStores.length === 0" class="store-locator__empty">
            <ng-container i18n="@@storeLocator.empty.title">沒有符合的分店</ng-container><br>
            <span i18n="@@storeLocator.empty.subtitle">No matching stores</span>
          </li>
        </ul>
      </aside>

      <!-- MAP -->
      <div class="store-locator__map">
        <iframe
          class="store-locator__map-frame"
          [src]="mapSrc"
          i18n-title="@@storeLocator.map.title"
          title="分店位置地圖"
          loading="lazy"
          allowfullscreen></iframe>
      </div>

    </div>
  </div>
</section>
